export default class ApprovalAction {
    static GET_APPROVAL_LIST_REQUEST = 'GET_APPROVAL_LIST_REQUEST';
    static GET_APPROVAL_LIST_SUCCESS = 'GET_APPROVAL_LIST_SUCCESS';
    static GET_APPROVAL_LIST_FAILED = 'GET_APPROVAL_LIST_FAILED';

    static approvalList_Request() {
        return {
            type: this.GET_APPROVAL_LIST_REQUEST
        }
    }

    static approvalList_Success(data) {
        return {
            type: this.GET_APPROVAL_LIST_SUCCESS,
            data
        }
    }

    static approvalList_Failed(error) {
        return {
            type: this.GET_APPROVAL_LIST_FAILED,
            error
        }
    }

    // Specific activity

    static GET_SPECIFIC_ACTIVITY_REQUEST = 'GET_SPECIFIC_ACTIVITY_REQUEST';
    static GET_SPECIFIC_ACTIVITY_SUCCESS = 'GET_SPECIFIC_ACTIVITY_SUCCESS';
    static GET_SPECIFIC_ACTIVITY_FAILED = 'GET_SPECIFIC_ACTIVITY_FAILED';

    static specificActivity_Request() {
        return {
            type: this.GET_SPECIFIC_ACTIVITY_REQUEST
        }
    }

    static specificActivity_Success(data) {
        return {
            type: this.GET_SPECIFIC_ACTIVITY_SUCCESS,
            data
        }
    }

    static specificActivity_Failed(error) {
        return {
            type: this.GET_SPECIFIC_ACTIVITY_FAILED,
            error
        }
    }

    // Submit Approval

    static POST_SUBMIT_APPROVAL_REQUEST = 'POST_SUBMIT_APPROVAL_REQUEST';
    static POST_SUBMIT_APPROVAL_SUCCESS = 'POST_SUBMIT_APPROVAL_SUCCESS';
    static POST_SUBMIT_APPROVAL_FAILED = 'POST_SUBMIT_APPROVAL_FAILED';

    static submitApproval_Request() {
        return {
            type: this.POST_SUBMIT_APPROVAL_REQUEST
        }
    }

    static submitApproval_Success(data) {
        return {
            type: this.POST_SUBMIT_APPROVAL_SUCCESS,
            data
        }
    }

    static submitApproval_Failed(error) {
        return {
            type: this.POST_SUBMIT_APPROVAL_FAILED,
            error
        }
    }

    //SUBMIT APROVAL FOR MTFTS REQUEST
    static POST_MTFTS_SUBMIT_APPROVAL_REQUEST = 'POST_MTFTS_SUBMIT_APPROVAL_REQUEST';
    static POST_MTFTS_SUBMIT_APPROVAL_SUCCESS = 'POST_MTFTS_SUBMIT_APPROVAL_SUCCESS';
    static POST_MTFTS_SUBMIT_APPROVAL_FAILED = 'POST_MTFTS_SUBMIT_APPROVAL_FAILED';

    static mtfts_submitApproval_Request() {
        return {
            type: this.POST_MTFTS_SUBMIT_APPROVAL_REQUEST
        }
    }

    static mtfts_submitApproval_Success(data) {
        return {
            type: this.POST_MTFTS_SUBMIT_APPROVAL_SUCCESS,
            data
        }
    }

    static mtfts_submitApproval_Failed(error) {
        return {
            type: this.POST_MTFTS_SUBMIT_APPROVAL_FAILED,
            error
        }
    }

    //SUBMIT APROVAL FOR MTFTS REQUEST


    // Approval History

    static GET_APPROVAL_HISTORY_REQUEST = 'GET_APPROVAL_HISTORY_REQUEST';
    static GET_APPROVAL_HISTORY_SUCCESS = 'GET_APPROVAL_HISTORY_SUCCESS';
    static GET_APPROVAL_HISTORY_FAILED = 'GET_APPROVAL_HISTORY_FAILED';

    static Approval_History_Request() {
        return {
            type: this.GET_APPROVAL_HISTORY_REQUEST
        }
    }

    static Approval_History_Success(data) {
        return {
            type: this.GET_APPROVAL_HISTORY_SUCCESS,
            data
        }
    }

    static Approval_History_Failed(error) {
        return {
            type: this.GET_APPROVAL_HISTORY_FAILED,
            error
        }
    }


    // Approval SUBMIT

    static POST_APPROVAL_SUBMIT_REQUEST = 'POST_APPROVAL_SUBMIT_REQUEST';
    static POST_APPROVAL_SUBMIT_SUCCESS = 'POST_APPROVAL_SUBMIT_SUCCESS';
    static POST_APPROVAL_SUBMIT_FAILED = 'POST_APPROVAL_SUBMIT_FAILED';

    static Approval_Submit_Request() {
        return {
            type: this.POST_APPROVAL_SUBMIT_REQUEST
        }
    }

    static Approval_Submit_Success(data) {
        return {
            type: this.POST_APPROVAL_SUBMIT_SUCCESS,
            data
        }
    }

    static Approval_Submit_Failed(error) {
        return {
            type: this.POST_APPROVAL_SUBMIT_FAILED,
            error
        }
    }


    // PRE-OPSO SEND BACK History

    static GET_SENDBACK_HISTORY_REQUEST = 'GET_SENDBACK_HISTORY_REQUEST';
    static GET_SENDBACK_HISTORY_SUCCESS = 'GET_SENDBACK_HISTORY_SUCCESS';
    static GET_SENDBACK_HISTORY_FAILED = 'GET_SENDBACK_HISTORY_FAILED';

    static Sendback_History_Request() {
        return {
            type: this.GET_SENDBACK_HISTORY_REQUEST
        }
    }

    static Sendback_History_Success(data) {
        return {
            type: this.GET_SENDBACK_HISTORY_SUCCESS,
            data
        }
    }

    static Sendback_History_Failed(error) {
        return {
            type: this.GET_SENDBACK_HISTORY_FAILED,
            error
        }
    };

    // old preopso data ;

    static OLD_PREOPSO_DATA_REQUEST = 'OLD_PREOPSO_DATA_REQUEST';
    static OLD_PREOPSO_DATA_SUCCESS = 'OLD_PREOPSO_DATA_SUCCESS';
    static OLD_PREOPSO_DATA_FAILED = 'OLD_PREOPSO_DATA_FAILED';

    static old_preopso_data_Request() {
        return {
            type: this.OLD_PREOPSO_DATA_REQUEST
        }
    }

    static old_preopso_data_Success(data) {
        return {
            type: this.OLD_PREOPSO_DATA_SUCCESS,
            data
        }
    }

    static old_preopso_data_Failed(error) {
        return {
            type: this.OLD_PREOPSO_DATA_FAILED,
            error
        }
    };


}